import {apiGet, apiRequestWithOptions} from "./client";

export default async function GetsDirect(route) {
    return apiGet(route);
}

export async function GetsCustom(route, requestOptions) {
    return apiRequestWithOptions(route, requestOptions);
}

